import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface States {
  tabIndex: number;
}

const initialState: States = {
  tabIndex: 0,
};

export const clubhouseStaffEditClubhouseStaffSlice = createSlice({
  initialState,
  name: 'clubhouseStaffEditClubhouseStaff',
  reducers: {
    setTabIndex: (state, { payload }: PayloadAction<number>) => {
      state.tabIndex = payload;
    },
  },
});

export default clubhouseStaffEditClubhouseStaffSlice.reducer;

export const { setTabIndex: setTabIndexAction } =
  clubhouseStaffEditClubhouseStaffSlice.actions;
